import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import { MediumColumn as MediumColumnConfig } from '@bingads-webui-campaign/ad-groups-data';
import mediumTemplate from './medium.pug';

export class MediumColumn extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    const title = i18n.getString('ColumnName_Medium');

    super({
      ...MediumColumnConfig,
      title,
      sortable: 'Medium',
      type: 'string',
      helpId: 'Page_CampaignGrids_Medium',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });

    this.schemaI18n = new SchemaI18n({ i18n });
  }

  template({ value }) {
    return mediumTemplate({ value, schemaI18n: this.schemaI18n });
  }
}
